import axios from "axios";
import store from "@/store";
import router from "../../router";

const Axios = axios.create();

async function getConfig() {
  return (await axios.get("static/config.json")).data;
}

async function setHubConfigs(): Promise<void> {
  if (store.getters["hubAppConfig"] == undefined) {
    store.dispatch(
      "setHubAppConfig",
      (await axios.get("http://127.0.0.1:8085/getHubConfigs")).data
    );
  }
}

Axios.interceptors.request.use(async req => {
  try {
    await setHubConfigs();
  } catch (e) {
    console.error("hub app not running", e);
  }
  return req;
});

export default class RequestHandler {
  public async setHubConfigs() {
    return await setHubConfigs();
  }

  public async getConfig() {
    return await getConfig();
  }

  public async call(params: any): Promise<any> {
    const config = await getConfig();
    if (store.getters.userInfo.api_token !== "")
      params["api_token"] = store.getters.userInfo.api_token;

    try {
      const request = await Axios.post(config.config.apiUrl.host, params);
      return request.data;
    } catch (error) {
      if (
        error.response != undefined &&
        error.response.status != undefined &&
        error.response.status == "401"
      ) {
        router.push({ name: "Login" });
        return;
      }
      return Promise.reject(error);
    }
  }

  public async storeHubAppSettings(payload: any): Promise<any> {
    const form = new FormData();
    form.append("send", JSON.stringify(payload));
    const data = new URLSearchParams(form as any);
    try {
      await Axios.post("http://127.0.0.1:8085/setHubConfigs", data);
      store.dispatch("setHubAppConfig", payload);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public async getReceipt(params: any, display = true): Promise<void> {
    const config = await getConfig();
    if (store.getters.userInfo.api_token !== "")
      params["api_token"] = store.getters.userInfo.api_token;
    params["action"] = "generateReceipt";
    return await axios.post(config.config.apiUrl.host, params, {
      responseType: display ? "arraybuffer" : "blob"
    });
  }

  public async setHubAppMonetraCreds() {
    const config = await getConfig();
    const form = new FormData();
    const settings = {
      user: store.getters.userInfo.monetra_user,
      password: store.getters.userInfo.monetra_pass,
      monetraHost: config.config.monetraUrl.host
    };
    form.append("user", settings.user);
    form.append("password", settings.password);
    form.append("monetraHost", settings.monetraHost);
    const data = new URLSearchParams(form as any);
    await axios.post("http://127.0.0.1:8085/setMonetraCreds", data);
  }

  public async getConnectedDevices(): Promise<any> {
    return (await axios.post("http://127.0.0.1:8085/getConnectedDevices")).data;
  }

  public async getPrinters(): Promise<any> {
    return (await axios.get("http://127.0.0.1:8085/getAllPrinters")).data;
  }

  public async queryUniterm(params: any, timeout = 0): Promise<any> {
    try {
      await this.setHubAppMonetraCreds();
    } catch (e) {
      return Promise.reject(e);
    }
    const form = new FormData();
    Object.keys(params).forEach((key: string) => {
      form.append(key, params[key]);
    });

    const data = new URLSearchParams(form as any);

    return (
      await axios.post("http://127.0.0.1:8085/queryUniterm", data, {
        timeout: timeout
      })
    ).data;
  }

  public async getTicket(params: any): Promise<any> {
    try {
      await this.setHubAppMonetraCreds();
    } catch (e) {
      return Promise.reject(e);
    }
    const form = new FormData();
    Object.keys(params).forEach((key: string) => {
      form.append(key, params[key]);
    });

    const data = new URLSearchParams(form as any);

    return (await axios.post("http://127.0.0.1:8085/getTicket", data)).data;
  }

  public async printPDF(params: any): Promise<any> {
    const form = new FormData();
    form.append("send", JSON.stringify(params));
    const data = new URLSearchParams(form as any);

    return (await axios.post("http://127.0.0.1:8085/printBase64PDF", data))
      .data;
  }

  public async queryMonetra(params: any): Promise<any> {
    try {
      await this.setHubAppMonetraCreds();
    } catch (e) {
      return Promise.reject(e);
    }
    const form = new FormData();
    Object.keys(params).forEach((key: string) => {
      form.append(key, params[key]);
    });

    const data = new URLSearchParams(form as any);

    return (await axios.post("http://127.0.0.1:8085/queryMonetra", data)).data;
  }
}
